export default __webpack_public_path__ + "static/media/013-bollard.ed1ba63e.png";